

























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class ListEditor extends Vue implements Components.IEditor {
  @Prop() public items: any[]; //リスト
  @Prop() public modelName: string; //項目のクラス名
  @Prop() public parentKey: any;
  @Prop({ default: null }) public height: number;
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: false }) public primitive: boolean;
  @Prop({ default: null }) public defaultValue: any;
  @Prop({ default: true }) public tabLayout: boolean;
  @Prop({ default: '' }) public title: string;
  @Prop({ default: true }) public enabled: boolean;

  @Prop({ default: null }) public captions: Array<string>;
  @Prop({ default: null }) public widths: Array<number>;

  @Prop({ default: '' }) public gridKey: string;
  @Prop({ default: null }) public gridCaptions: Array<string>;
  @Prop({ default: null }) public gridWidths: Array<number>;
  @Prop({ default: null }) public listItems: any[]; //チェックボックスで選択して編集する場合にセット(itemsにBindItem.valueの配列をセット)
  @Prop({ default: null }) public listItemKey: (item:any)=> any;  //キーを取得する

  public isEdit: boolean = true;
  public tooltip:string = null;


  // チェックボックス付きの一覧エディタの実装
  public listChecked: boolean[];
  public showItemEditor: boolean = false;


  public onEditListItems(){
      //チェック状態を設定する
      this.listChecked = new Array(this.listItems.length);      //都度初期化する
      this.items.forEach(key => {
        //比較キー取得メソッドがない場合は直接比較する
        var index = this.listItems.findIndex(obj => this.listItemKey ? this.listItemKey(obj) == this.listItemKey(key) : obj == key);
        if (index > -1) this.listChecked[index] = true;
      });
      (this.$refs.editor as Components.Grid).checked = this.listChecked;
      //エディタを開く
      this.showItemEditor = true;          
  }
  public onOk(){
    //項目をセットする
    var selected = new Array();
    this.listChecked.forEach((value,index)=>{
      if(value)selected.push(this.listItems[index]);
    });
    this.$emit('update:items',selected);
  }  
  // チェックボックス付きの一覧エディタの実装(終わり)

  @Watch('isEdit')
  isEditChanged(newValue: boolean) {
    this.controls.forEach(obj => (obj.isEdit = newValue));
    if (this.isEdit) this.tooltip = null;
    else this.tooltip = '編集状態にすると使用できます';
  }
  public validator: Components.ControlValidator = null;

  public itemValidator: Components.Validator = new Components.Validator();

  public selectedItem: any = null; //リスト選択中の項目

  public controls: Components.IControl[] = new Array();
  public addControl(control: Components.IControl) {
    if (control.validator != null) {
      this.itemValidator.Validators.push(control.validator);
    }
    control.isEdit = this.isEdit;
    this.controls.push(control);

    if (this.primitive) {
      (control as any).$on('update:value', this.onUpdated);
    }
  }
  public removeControl(control: Components.IControl){
    if (control.validator != null) {
      var index = this.itemValidator.Validators.indexOf(control.validator);
      if (index != -1) this.itemValidator.Validators.splice(index, 1);
    }    
    var index1 = this.controls.indexOf(control);
    if (index1 != -1) this.controls.splice(index1, 1);    
  }

  public onUpdated(newItem: any) {
    //文字列・値などを直接バインドする場合〜どうやってコントロールにフックするんだ?
    this.$set(this.items, this.Grid.selectedId, newItem);
  }

  public get Grid(): Components.Grid {
    return this.$refs.listBox as Components.Grid;
  }

  public created() {
    // document.body.addEventListener('click', this.onClickOtherElement, {
    //   capture: true,
    // });
    // document.body.addEventListener('focusin', this.onClickOtherElement, {
    //   capture: true,
    // });
    //親Editorに登録する
    if (this.editor != null) this.editor.addControl(this);
  }
  public destroyed() {
    if (this.editor != null) this.editor.removeControl(this);
    // document.body.removeEventListener('click', this.onClickOtherElement, {
    //   capture: true,
    // });
    // document.body.removeEventListener('focusin', this.onClickOtherElement, {
    //   capture: true,
    // });
  }

  @Watch('parentKey')
  public onItemsChanged() {
    if (this.items != null && this.items.length > 0) {
      this.Grid.select(0);
    } else {
      this.selectedItem = null;
    }
  }
  // public onClickOtherElement(e: any) {
  //   if (this.isEdit) {
  //     const modal = document.getElementById('builtinModal');
  //     // リンクとカードはクリックをハックする(フォーカスだとtargetがDIVだったりするため)
  //     // 入力コントロールはフォーカスをハックする
  //     const el = this.$refs.editor as HTMLElement;

  //     if (el == undefined || el.contains(e.srcElement) || e.srcElement == (this.$refs.delete as Vue).$el) {
  //       return;
  //     } else if (e.type == 'focusin' && e.srcElement.tagName.toLowerCase() != 'input' && e.srcElement.tagName.toLowerCase() != 'select') {
  //       return;
  //     } else if (modal != null && modal.contains(e.srcElement)) {
  //       return;
  //     }

  //     console.log('outside click on listEditor');

  //     if (this.itemValidator.validate() == false) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       e.stopImmediatePropagation();
  //       return false;
  //     }
  //   }
  // }

  public onSelected(index: number) {
    this.selectedItem = this.items[index];
  }

  public onEdit() {

    if(this.listItems){
      this.onEditListItems();
      return;
    }

    //キャンセルがあるのでクローンしたリストをセットする
    const temp = new Array();
    this.items.forEach((obj, index) => {
      if (this.primitive) {
        temp.push({ value: obj });
      } else {
        let objBase = obj as Common.ObjectBase;
        temp.push(objBase.binder.loadInstance(objBase));
      }
    });
    (this.$refs.dialog as Components.ListDialog).items = temp;
    (this.$refs.dialog as Components.ListDialog).showDialog();
  }

  public onEditComplete(list: Array<any>) {
    //配列そのものを入替え
    this.$emit('update:items', list);
  }
}
